import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const API_BASE = process.env.REACT_APP_API_URL;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Logging in...", {
      position: "top-center",
    });

    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // required to handle cookies
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok && data.user) {
        sessionStorage.setItem("user", JSON.stringify(data.user));
        toast.update(loadingToastId, {
          render: "Login successful 🎉 Redirecting...",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else if (data.error === "Email not verified") {
        toast.update(loadingToastId, {
          render: "Email not verified. Please check your inbox.",
          type: "warning",
          isLoading: false,
          autoClose: 4000,
        });

        // Optionally: prompt user to resend verification
        // You can add a modal or link to trigger that
      } else {
        toast.update(loadingToastId, {
          render: data.error || "Invalid email or password",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }

    } catch (err) {
      console.error("Login error:", err);
      toast.update(loadingToastId, {
        render: "Something went wrong. Try again.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center ">
      <form
        onSubmit={handleLogin}
        className="bg-sky-800 p-8 rounded-lg shadow-2xl shadow-black w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-200">
          Login
        </h2>

        <input
          type="email"
          placeholder="Email"
          className="w-full mb-4 p-2 border border-gray-300 rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <div className="relative w-full mb-4">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="w-full p-2 border border-gray-300 rounded"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2.5 cursor-pointer text-gray-500 text-sm select-none"
          >
            {showPassword ? "Hide" : "Show"}
          </span>
        </div>

        <p className="text-sm text-right mb-4">
          <Link to="/forgot-password" className="text-blue-100 hover:underline">
            Forgot Password?
          </Link>
        </p>

        <button
          type="submit"
          className="w-full bg-cyan-600 text-white py-2 rounded hover:bg-cyan-700"
        >
          Login
        </button>

        <p className="mt-4 text-sm text-center text-gray-200">
          Don’t have an account?{" "}
          <Link to="/signup" className="text-cyan-300 hover:underline">
            Sign Up
          </Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
